import request from '@/utils/request'

// 新增客户反馈信息
export function addFeedback(data) {
    return request({
      url: '/web/menu/addfeedback',
      method: 'post',
      data: data
    })
  }